var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paperless", on: { click: _vm.clearViewport } },
    [
      _c("orderPending", {
        ref: "orderPending",
        attrs: {
          drawer: _vm.drawer,
          type: _vm.drawerType,
          orderData: _vm.orderData,
          departmentList: _vm.departmentPerformanceList,
          currentSelectedMember: _vm.currentSelectedMember,
          currentlySelectedCard: _vm.currentlySelectedCard,
          orderTypes: _vm.orderTypes,
          orderPrice: _vm.orderPrice,
          DepartmentalList: _vm.DepartmentalPerformance,
          isDepartmentalPerformance: _vm.isDepartmentalPerformance,
          orderDataHasBeenPosted: _vm.orderDataHasBeenPosted
        },
        on: {
          upDrawer: _vm.upDrawer,
          clearOrderInfo: _vm.clearOrderInfo,
          "update:DepartmentalList": function($event) {
            _vm.DepartmentalPerformance = $event
          },
          "update:departmental-list": function($event) {
            _vm.DepartmentalPerformance = $event
          },
          updateDepartmentalList: _vm.updateDepartmentalList,
          selectMemberInformation: _vm.selectMemberInformation,
          updateMemberInformation: _vm.updateMemberInformation,
          updateTag: _vm.updateTag,
          getTheListOfOrderingData: _vm.getTheListOfOrderingData,
          updateOrderData: _vm.updateOrderData,
          getThePendingOrderNumber: _vm.getThePendingOrderNumber,
          modifyADesignation: _vm.setModifyADesignation,
          research: _vm.research
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "navigationBar",
          style: _vm.drawer ? { display: "none" } : { display: "block" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.storePerformanceAuthority || _vm.employeePerformanceAuthority
            ? [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "reportPopUp" },
                  [
                    _vm.storePerformanceAuthority
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "reportPopUp-item",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.openWindows(
                                    _vm.$router.resolve({ name: "money" })
                                  )
                                }
                              }
                            },
                            [_vm._v("门店业绩")]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.employeePerformanceAuthority
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "reportPopUp-item",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.openWindows(
                                    _vm.$router.resolve({ name: "data" })
                                  )
                                }
                              }
                            },
                            [_vm._v("员工数据")]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.orderManagementAuthority
            ? [
                _c(
                  "div",
                  {
                    staticClass: "nva-item orderData",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.openWindows(_vm.$router.resolve({ name: "order" }))
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "iconfont icon-dingdan" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("订单")])
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.memberCenterManagementRights
            ? [
                _c(
                  "div",
                  {
                    staticClass: "nva-item",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.openWindows(_vm.$router.resolve({ name: "member" }))
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "iconfont icon-yuangong" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("顾客")])
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          [
            _vm.whetherToEnableThecDInSetting
              ? _c(
                  "div",
                  {
                    staticClass: "nva-item",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.turnOnTheClock.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "iconfont icon-daka" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("打卡")])
                  ]
                )
              : _vm._e()
          ],
          _vm._v(" "),
          _c("div", { staticClass: "operation" }, [
            _c(
              "div",
              {
                staticClass: "fullScreenDisplay",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.switchDisplay.apply(null, arguments)
                  }
                }
              },
              [
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPic,
                      expression: "isPic"
                    }
                  ],
                  staticClass: "iconfont icon-T"
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isPic,
                      expression: "!isPic"
                    }
                  ],
                  staticClass: "iconfont icon-yingyong"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fullScreenDisplay",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.Fkey.apply(null, arguments)
                  }
                }
              },
              [
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.flag,
                      expression: "!flag"
                    }
                  ],
                  staticClass: "iconfont icon-quanping"
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.flag,
                      expression: "flag"
                    }
                  ],
                  staticClass: "iconfont icon-suoxiao"
                })
              ]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "paperlessLeft" },
        [
          _vm.searchInputBoxShow
            ? _c(
                "div",
                {
                  staticClass: "itemQueryCt",
                  staticStyle: {
                    height: "40px",
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "center",
                    "align-items": "center",
                    gap: "15px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { height: "40px", display: "flex" },
                      attrs: { "data-tag": "employeeViewport" }
                    },
                    [
                      _c("el-input", {
                        ref: "itemQueryRef",
                        staticStyle: { margin: "auto" },
                        attrs: {
                          "data-tag": "employeeViewport",
                          placeholder: "请输入项目编号",
                          size: "medium"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            return _vm.filterItemData.apply(null, arguments)
                          },
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.selectFirstItem.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.queryItem,
                          callback: function($$v) {
                            _vm.queryItem = $$v
                          },
                          expression: "queryItem"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    staticStyle: {
                      color: "grey",
                      "font-size": "20px",
                      padding: "0"
                    },
                    attrs: { type: "text", icon: "el-icon-close" },
                    on: {
                      click: function($event) {
                        return _vm.closeSearch()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "titleBar" }, [
            _c(
              "div",
              { staticClass: "selectionbar" },
              _vm._l(_vm.selectionBar, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "selectionbar-item" },
                  [
                    _c(
                      "span",
                      {
                        class: item.id === _vm.filterType ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.switchingType(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "operationType" },
              _vm._l(_vm.operationType, function(item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "operationType-item",
                    on: {
                      click: function($event) {
                        return _vm.operation(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "content" }, [
                      _c("span", { class: "iconfont " + item.icon }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      item.id === 1
                        ? _c("span", { staticClass: "topLeftCorner" }, [
                            _vm._v(_vm._s(_vm.orderDataNumber))
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-body" },
            [
              [
                _c(
                  "div",
                  { staticClass: "projectType-box" },
                  [
                    _c(
                      "el-skeleton",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          animated: "",
                          loading: _vm.projectTypeList.length === 0
                        }
                      },
                      [
                        _c("template", { slot: "template" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c("el-skeleton-item", {
                                staticStyle: {
                                  width: "600px",
                                  "margin-top": "15px"
                                },
                                attrs: { variant: "h1" }
                              }),
                              _vm._v(" "),
                              _c("el-skeleton-item", {
                                staticStyle: {
                                  width: "300px",
                                  "margin-top": "30px"
                                },
                                attrs: { variant: "h1" }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        [
                          _c(
                            "div",
                            { staticClass: "projectType" },
                            _vm._l(_vm.projectTypeList, function(item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  class:
                                    index === _vm.projectType
                                      ? "projectType-item active"
                                      : "projectType-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.switchItems(item, index)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(item.dictName))])]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "alphabeticScreening" },
                            _vm._l(_vm.alphabeticScreening, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item,
                                  class:
                                    item === _vm.letter
                                      ? "alphabeticScreening-item active"
                                      : "alphabeticScreening-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.switchingFilterCondition(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.toUpperCase()))]
                              )
                            }),
                            0
                          )
                        ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-skeleton",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { animated: "", loading: _vm.projectList.length === 0 }
            },
            [
              _vm.isPic
                ? [
                    _c(
                      "div",
                      { staticClass: "content-body-pic" },
                      _vm._l(_vm.projectList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class:
                              _vm.theProjectSelectsGlobalListening === index
                                ? "content-body-item active"
                                : "content-body-item",
                            attrs: { "data-tag": "openEmployeeViewport" },
                            on: {
                              click: function($event) {
                                return _vm.option(item, undefined, index)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "projectName",
                                style: {
                                  backgroundImage:
                                    "url(" +
                                    (item.picture ||
                                      "https://gd3.alicdn.com/imgextra/i3/62247684/O1CN01rLN5Hl26dKB3MoYGU_!!62247684.jpg") +
                                    ")",
                                  backgroundSize: "100% 100%"
                                },
                                attrs: { "data-tag": "openEmployeeViewport" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "itemNumber",
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterType === 0
                                          ? item.packageCode
                                          : item.productCode
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.productInventoryNumberPermission
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.stock !== undefined,
                                              expression:
                                                "item.stock !== undefined"
                                            }
                                          ],
                                          staticClass: "inventory",
                                          attrs: {
                                            "data-tag": "openEmployeeViewport"
                                          }
                                        },
                                        [
                                          _c("i", [_vm._v("库存")]),
                                          _vm._v(" "),
                                          _c(
                                            "i",
                                            {
                                              class:
                                                item.stock <= 0
                                                  ? "active pic_active"
                                                  : "pic_active"
                                            },
                                            [_vm._v(_vm._s(item.stock))]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "projectInfo",
                                attrs: { "data-tag": "openEmployeeViewport" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: item.stock <= 0 ? "active" : "",
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterType === 0
                                          ? _vm.textLength(item.packageName)
                                          : _vm.textLength(item.productName)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "priceInventory",
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-tag": "openEmployeeViewport"
                                        }
                                      },
                                      [_vm._v("￥" + _vm._s(item.price))]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "content-body" },
                      _vm._l(_vm.projectList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class:
                              _vm.theProjectSelectsGlobalListening === index
                                ? "content-body-item active"
                                : "content-body-item",
                            attrs: { "data-tag": "openEmployeeViewport" },
                            on: {
                              click: function($event) {
                                return _vm.option(item, undefined, index)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "projectName",
                                attrs: { "data-tag": "openEmployeeViewport" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterType === 0
                                          ? item.packageCode
                                          : item.productCode
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: item.stock <= 0 ? "active" : "",
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterType === 0
                                          ? _vm.textLength(item.packageName)
                                          : _vm.textLength(item.productName)
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "projectInfo",
                                attrs: { "data-tag": "openEmployeeViewport" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  },
                                  [_vm._v("￥" + _vm._s(item.price))]
                                ),
                                _vm._v(" "),
                                _vm.productInventoryNumberPermission
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.stock !== undefined,
                                              expression:
                                                "item.stock !== undefined"
                                            }
                                          ],
                                          attrs: {
                                            "data-tag": "openEmployeeViewport"
                                          }
                                        },
                                        [
                                          _c("i", [_vm._v("库存:")]),
                                          _vm._v(" "),
                                          _c(
                                            "i",
                                            {
                                              class:
                                                item.stock <= 0 ? "active" : ""
                                            },
                                            [_vm._v(_vm._s(item.stock))]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "employeeRef",
              staticClass: "employeeList",
              attrs: { "data-tag": "employeeViewport" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "title",
                  attrs: { "data-tag": "employeeViewport" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title-input",
                      attrs: { "data-tag": "employeeViewport" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.employeeNumber,
                            expression: "employeeNumber",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "员工编号",
                          "data-tag": "employeeViewport"
                        },
                        domProps: { value: _vm.employeeNumber },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.employeeNumber = $event.target.value.trim()
                            },
                            _vm.searchForEmployees
                          ],
                          focus: _vm.noDisplay,
                          blur: [
                            _vm.permittedDisplay,
                            function($event) {
                              return _vm.$forceUpdate()
                            }
                          ]
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "iconfont icon-guanbi",
                    attrs: { "data-tag": "employeeViewport" },
                    on: { click: _vm.closeEmployeeViewport }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.employeeList.length
                ? _vm._l(_vm.employeeList, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.postId,
                        staticClass: "con",
                        attrs: { "data-tag": "employeeViewport" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "position",
                            attrs: { "data-tag": "employeeViewport" }
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont icon-zhiwei",
                              attrs: { "data-tag": "employeeViewport" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { "data-tag": "employeeViewport" } },
                              [_vm._v(_vm._s(item.postName))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "staff",
                            attrs: { "data-tag": "employeeViewport" }
                          },
                          _vm._l(item.positionEmployee, function(subItem) {
                            return _c(
                              "div",
                              {
                                key: subItem.id,
                                class: subItem.label
                                  ? "staff-item active"
                                  : "staff-item",
                                attrs: { "data-tag": "employeeViewport" },
                                on: {
                                  click: function($event) {
                                    return _vm.selectEmployees(subItem)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "data-tag": "employeeViewport" } },
                                  [_vm._v(_vm._s(subItem.employeeNo))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { "data-tag": "employeeViewport" } },
                                  [_vm._v(_vm._s(subItem.employeeName))]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: subItem.numberOfAdditions,
                                      expression: "subItem.numberOfAdditions"
                                    }
                                  ],
                                  staticClass: "iconfont icon-chacha",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.removeAnEmployee(
                                        subItem.employeeNo
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: subItem.numberOfAdditions,
                                        expression: "subItem.numberOfAdditions"
                                      }
                                    ]
                                  },
                                  [_vm._v(_vm._s(subItem.numberOfAdditions))]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  })
                : [_vm._m(2)]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.currentSelectedMember.id,
                  expression: "!currentSelectedMember.id"
                }
              ],
              ref: "memberBoxRef",
              staticClass: "member-box"
            },
            [
              _c(
                "div",
                {
                  ref: "memberEmployeeRef",
                  staticClass: "memberEmployee",
                  attrs: { "data-tag": "memberViewport" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "member-title",
                      attrs: { "data-tag": "memberViewport" }
                    },
                    [
                      _c("span", { attrs: { "data-tag": "memberViewport" } }, [
                        _vm._v("确认会员")
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "iconfont icon-closel",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.research.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "member-content",
                      attrs: { "data-tag": "memberViewport" }
                    },
                    _vm._l(_vm.memberList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          class: item.cardShow
                            ? "member-content-item"
                            : "member-content-item activeHover",
                          attrs: { "data-tag": "memberViewport" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectMemberInformation(item)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "member-headers",
                              attrs: { "data-tag": "memberViewport" }
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "default_head",
                                style: item.gzhState
                                  ? { color: "#55a532" }
                                  : { color: "red" },
                                attrs: { "icon-class": "default_head" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "member-info",
                              attrs: { "data-tag": "memberViewport" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "member-user",
                                  attrs: { "data-tag": "memberViewport" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "member-name",
                                      attrs: { "data-tag": "memberViewport" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "highlight",
                                              rawName: "v-highlight",
                                              value: _vm.resetMemberName(item),
                                              expression:
                                                "resetMemberName(item)"
                                            }
                                          ],
                                          attrs: {
                                            "data-tag": "memberViewport"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("filterMemberName")(item)
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "member-integral",
                                      attrs: { "data-tag": "memberViewport" }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icon-huiyuanqia",
                                        attrs: { "data-tag": "memberViewport" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-tag": "memberViewport"
                                          }
                                        },
                                        [_vm._v("会员号:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "highlight",
                                              rawName: "v-highlight",
                                              value: item.memberNo,
                                              expression: "item.memberNo"
                                            }
                                          ],
                                          attrs: {
                                            "data-tag": "memberViewport"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.memberNo))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "member-phone",
                                      attrs: { "data-tag": "memberViewport" }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icon-shoujihao",
                                        attrs: { "data-tag": "memberViewport" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "highlight",
                                              rawName: "v-highlight",
                                              value: item.memberMobile,
                                              expression: "item.memberMobile"
                                            }
                                          ],
                                          attrs: {
                                            "data-tag": "memberViewport"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.memberMobile))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "member-integral",
                                      attrs: { "data-tag": "memberViewport" }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icon-jifen",
                                        attrs: { "data-tag": "memberViewport" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-tag": "memberViewport"
                                          }
                                        },
                                        [_vm._v("积分:")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-tag": "memberViewport"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.pointValue))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    class: item.cardShow
                                      ? "iconfont icon-zhankai"
                                      : "iconfont icon-shouqi",
                                    attrs: { "data-tag": "memberViewport" },
                                    on: {
                                      click: function($event) {
                                        if (
                                          $event.target !== $event.currentTarget
                                        ) {
                                          return null
                                        }
                                        $event.stopPropagation()
                                        return _vm.expansionCardDetails(
                                          item,
                                          index
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              item.currentMembershipCardList
                                ? _c(
                                    "div",
                                    {
                                      class: item.cardShow
                                        ? "member-card active"
                                        : "member-card",
                                      attrs: { "data-tag": "memberViewport" }
                                    },
                                    _vm._l(
                                      item.currentMembershipCardList,
                                      function(subItem) {
                                        return _c(
                                          "div",
                                          {
                                            key: subItem.tmemberCard.id,
                                            class: item.cardShow
                                              ? "member-card-item activeHover"
                                              : "member-card-item",
                                            attrs: {
                                              "data-tag": "memberViewport"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.selectMemberInformation(
                                                  item,
                                                  subItem
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card-pic",
                                                attrs: {
                                                  "data-tag": "memberViewport"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm._f(
                                                      "filterCardPic"
                                                    )(
                                                      subItem.tmemberCard
                                                        .cardTypeCode,
                                                      "img"
                                                    ),
                                                    "data-tag":
                                                      "memberViewport",
                                                    height: "30px",
                                                    alt: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-info",
                                                    attrs: {
                                                      "data-tag":
                                                        "memberViewport"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-tag":
                                                            "memberViewport"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            subItem.tmemberCard
                                                              .cardName
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              subItem
                                                                .tmemberCard
                                                                .cardNo
                                                                ? "（" +
                                                                    subItem
                                                                      .tmemberCard
                                                                      .cardNo +
                                                                    "）"
                                                                : ""
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-tag":
                                                            "memberViewport"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "有效期:\n                        无限期"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cardBalance",
                                                attrs: {
                                                  "data-tag": "memberViewport"
                                                }
                                              },
                                              [
                                                subItem.tmemberCard
                                                  .cardTypeCode === 3
                                                  ? [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            "data-tag":
                                                              "memberViewport"
                                                          }
                                                        },
                                                        [_vm._v("卡余次：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            "data-tag":
                                                              "memberViewport"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.isRemaindTotalCountInfinite(
                                                                subItem
                                                                  .tmemberCard
                                                                  .remaindTotalCount
                                                              )
                                                            ) + "次"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            "data-tag":
                                                              "memberViewport"
                                                          }
                                                        },
                                                        [_vm._v("卡余额：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "balance",
                                                          attrs: {
                                                            "data-tag":
                                                              "memberViewport"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "￥" +
                                                              _vm._s(
                                                                subItem
                                                                  .tmemberCard
                                                                  .initAmount
                                                              )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            "data-tag":
                                                              "memberViewport"
                                                          }
                                                        },
                                                        [_vm._v("赠金：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "balance",
                                                          attrs: {
                                                            "data-tag":
                                                              "memberViewport"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "￥" +
                                                              _vm._s(
                                                                subItem
                                                                  .tmemberCard
                                                                  .givenAmount
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.recordOrNot,
                  expression: "recordOrNot"
                }
              ],
              staticClass: "recordingIdentification"
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.handBrand.split(":")[1] ? "订单号" : "手牌号")
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("#" + _vm._s(_vm.handBrand.split(":")[0]))]),
              _vm._v(" "),
              _c("span", [_vm._v("录单中...")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.cancelBooking.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "paperlessRightRef", staticClass: "paperlessRight" },
        [
          !_vm.currentSelectedMember.id
            ? [
                _c(
                  "div",
                  {
                    ref: "memberInformationRef",
                    staticClass: "searchUserName",
                    attrs: { "data-tag": "clear" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "contentInput",
                        attrs: { "data-tag": "clear" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchContent,
                              expression: "searchContent"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "手机号码/会员号/会员姓名/会员昵称",
                            "data-tag": "clear"
                          },
                          domProps: { value: _vm.searchContent },
                          on: {
                            focus: _vm.memberSearchFocus,
                            compositionend: _vm.searchMembership,
                            compositionstart: _vm.searchMembership,
                            keyup: _vm.searchMembership,
                            blur: function($event) {
                              _vm.queryItem = ""
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchContent = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "iconfont icon-chazhaoyonghu",
                          attrs: { "data-tag": "clear" }
                        })
                      ]
                    )
                  ]
                )
              ]
            : [
                _c(
                  "div",
                  {
                    ref: "memberInformationRef",
                    staticClass: "memberInformation"
                  },
                  [
                    _c("div", { staticClass: "userInfo" }, [
                      _c(
                        "div",
                        {
                          staticClass: "user-header-pic",
                          on: { click: _vm.jumpDetails }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.currentSelectedMember.id
                                ? _vm.currentSelectedMember.memberPortrait ||
                                  "https://s1.ax1x.com/2018/12/22/FykFr4.png"
                                : "https://s1.ax1x.com/2018/12/22/FykFr4.png",
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-info" }, [
                        _c("div", { staticClass: "usercontent" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.currentSelectedMember.memberName))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "phone" }, [
                            _vm._v(
                              _vm._s(_vm.currentSelectedMember.memberMobile)
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "membershipNumber" }, [
                            _c("i", [
                              _vm._v(
                                "#" + _vm._s(_vm.currentSelectedMember.memberNo)
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rechargeAndOpenACard" }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.membershipCardOpening(true)
                                }
                              }
                            },
                            [_vm._v("开卡")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "text-decoration": "none",
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _vm.storeGlobalSettingStatus("启用会员积分")
                                ? [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon",
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: { href: "#icon-jifen3" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "i",
                                      {
                                        staticStyle: {
                                          margin: "0 5px",
                                          color: "#f683a2",
                                          "font-weight": "bold"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentSelectedMember.pointValue
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "iconfont icon-zengjia-fang",
                                      staticStyle: {
                                        "font-size": "20px",
                                        margin: "0 5px"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.modifiedIntegral("add")
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-jianshao-fang",
                                      staticStyle: {
                                        "font-size": "20px",
                                        margin: "0 5px"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.modifiedIntegral("remove")
                                        }
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "iconfont icon-chazhaoyonghu",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.research(true)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cardList" },
                      _vm._l(
                        _vm.currentSelectedMember.currentMembershipCardList,
                        function(item) {
                          return _c(
                            "div",
                            {
                              key: item.tmemberCard.id,
                              class:
                                _vm.currentlySelectedCard.tmemberCard.id ===
                                item.tmemberCard.id
                                  ? "cardList-item active"
                                  : "cardList-item",
                              on: {
                                click: function($event) {
                                  return _vm.selectMembershipCard(item)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(item.tmemberCard.cardName))
                              ])
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _vm.currentlySelectedCard
                      ? [
                          _c("div", { staticClass: "otherOperations" }, [
                            _c("img", {
                              attrs: {
                                src: _vm._f("filterCardPic")(
                                  _vm.currentlySelectedCard.tmemberCard
                                    .cardTypeCode,
                                  "bg"
                                ),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-Info-content" }, [
                              _c(
                                "div",
                                { staticClass: "card-title" },
                                [
                                  _c("div", { staticClass: "card-info-name" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentlySelectedCard.tmemberCard
                                            .cardName
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "infocard" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentlySelectedCard.tmemberCard
                                            .cardTypeName
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentlySelectedCard.tmemberCard
                                      .cardTypeCode !== 3 &&
                                    _vm.currentlySelectedCard.tmemberCard
                                      .cardTypeCode !== 0
                                      ? _c(
                                          "span",
                                          { staticClass: "infocard" },
                                          [_vm._v("开卡日期")]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentlySelectedCard.tmemberCard
                                    .cardTypeCode === 3 ||
                                  _vm.currentlySelectedCard.tmemberCard
                                    .cardTypeCode === 0
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "cardBalance" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "kagin" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cardBalance-content"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("卡余次:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.isRemaindTotalCountInfinite(
                                                            _vm
                                                              .currentlySelectedCard
                                                              .tmemberCard
                                                              .remaindTotalCount
                                                          )
                                                        ) + "次"
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cardBalance-content"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("开卡日期:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .currentlySelectedCard
                                                            .tmemberCard
                                                            .addDate &&
                                                            _vm.currentlySelectedCard.tmemberCard.addDate.split(
                                                              " "
                                                            )[0]
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm.currentlySelectedCard.tmemberCard
                                        .cardTypeCode === 2
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "cardBalance" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "kagin" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cardBalance-content"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("卡余额:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("amountType")(
                                                            Number(
                                                              _vm
                                                                .currentlySelectedCard
                                                                .tmemberCard
                                                                .initAmount
                                                            ) +
                                                              Number(
                                                                _vm
                                                                  .currentlySelectedCard
                                                                  .tmemberCard
                                                                  .givenAmount
                                                              )
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        on: {
                                                          click:
                                                            _vm.openTheRechargePage
                                                        }
                                                      },
                                                      [_vm._v("充值")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "kagin-content"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("本金:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("amountType")(
                                                            _vm
                                                              .currentlySelectedCard
                                                              .tmemberCard
                                                              .initAmount
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v("赠金:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("amountType")(
                                                            _vm
                                                              .currentlySelectedCard
                                                              .tmemberCard
                                                              .givenAmount
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cardBalance-content"
                                                  },
                                                  [
                                                    _c("span"),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .currentlySelectedCard
                                                            .tmemberCard
                                                            .addDate &&
                                                            _vm.currentlySelectedCard.tmemberCard.addDate.split(
                                                              " "
                                                            )[0]
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "projectInclusion" },
                                _vm._l(
                                  _vm.currentlySelectedCard.cardDetail,
                                  function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "projectInclusion-item",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.lockingSeries(
                                              item.parentId,
                                              item.id,
                                              $event
                                            )
                                          },
                                          touchstart: function($event) {
                                            return _vm.handleTouchStart(
                                              item.parentId,
                                              item.id,
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "warning"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "" +
                                                  (item.parentName
                                                    ? item.parentName + "-"
                                                    : "") +
                                                  (item.cardName.split(
                                                    "-"
                                                  )[1] ||
                                                    item.cardName.split(
                                                      "-"
                                                    )[0]) +
                                                  "-" +
                                                  item.cardCount +
                                                  "次"
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "availabilityPeriod" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cardRemarks",
                                    on: { click: _vm.openRemarksModification }
                                  },
                                  [
                                    _c("span", [_vm._v("卡备注：")]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-overflow": "ellipsis",
                                          "white-space": "nowrap",
                                          overflow: "hidden"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentlySelectedCard
                                              .tmemberCard.remark
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "periodOfValidity" }, [
                                  _c("span", [_vm._v("有效期：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f(
                                          "filterCalculationCardValidityPeriod"
                                        )(
                                          _vm.currentlySelectedCard.tmemberCard
                                            .effectiveDays
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "orderContent",
              style: { height: _vm.orderHeight + "px" }
            },
            [
              _vm.orderData.length
                ? _vm._l(_vm.orderData, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class:
                          _vm.currentProjectSubscript === index
                            ? "orderContent-item active"
                            : "orderContent-item"
                      },
                      [
                        _c("div", { staticClass: "order-title" }, [
                          _c("span", [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(item.packageName || item.productName) +
                                  " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("i", [
                              _vm._v(_vm._s(_vm._f("amountType")(item.price)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.packageTypeName || item.productTypeName
                                ) +
                                " "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.modifiedSettlementPrice(
                                    item,
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "b",
                                {
                                  style: item.isDiscount
                                    ? { color: "green" }
                                    : { color: "#f64e60" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("amountType")(item.total)) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "iconfont icon-bianji1",
                                style: item.isDiscount
                                  ? { color: "green" }
                                  : { color: "#f64e60" }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.analyticalDataCommodity(item) === "0"
                          ? [
                              _vm._l(item.handerNum, function(
                                subItem,
                                subIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: subIndex,
                                    staticClass: "jobList",
                                    staticStyle: { padding: "0px" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openAddStaff(index, $event)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "jobList_item",
                                        class: {
                                          "highlight-job":
                                            _vm.highlightOrderIndex === index &&
                                            _vm.highlightWorkType ===
                                              _vm.analyticalWork(subItem)
                                        },
                                        attrs: {
                                          "data-tag": "openEmployeeViewport",
                                          "data-workType": _vm.analyticalWork(
                                            subItem
                                          )
                                        }
                                      },
                                      [
                                        _vm.analyzeWhetherThereAreJobs(
                                          _vm.analyticalWork(subItem),
                                          item.employeeList
                                        )
                                          ? _vm._l(item.employeeList, function(
                                              employeeItem,
                                              employeeIndex
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        employeeItem.workTypeName ===
                                                        _vm.analyticalWork(
                                                          subItem
                                                        ),
                                                      expression:
                                                        "employeeItem.workTypeName === analyticalWork(subItem)"
                                                    }
                                                  ],
                                                  key: employeeIndex,
                                                  staticClass:
                                                    "jobList_item_data",
                                                  staticStyle: {
                                                    margin: "0 5px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "staff" },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "iconfont icon-shanchu",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.projectDeletionEmployee(
                                                              index,
                                                              employeeItem.workTypeName
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _c("i", [
                                                          _vm._v(
                                                            _vm._s(
                                                              employeeItem.employeeName
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("i", [
                                                          _vm._v(
                                                            _vm._s(
                                                              employeeItem.postName
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.appointBrokerage === 0
                                                    ? [_vm._m(3, true)]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              employeeItem.appoint ===
                                                              0
                                                                ? "staffInfo"
                                                                : "staffInfo active",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.modifyADesignation(
                                                                  item,
                                                                  employeeItem,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "iconfont icon-bianji1"
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  employeeItem.appoint ===
                                                                    0
                                                                    ? "非指定"
                                                                    : "指定"
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "staffInfo",
                                                        staticStyle: {
                                                          "user-select": "none",
                                                          cursor: "no-drop",
                                                          "margin-left": "25px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#1E90FF"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.analyticalWork(
                                                                  subItem
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ],
                                                2
                                              )
                                            })
                                          : [
                                              _c("span", {
                                                staticClass:
                                                  "iconfont icon-tianjia",
                                                attrs: {
                                                  "data-tag":
                                                    "openEmployeeViewport",
                                                  "data-workType": _vm.analyticalWork(
                                                    subItem
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-tag":
                                                      "openEmployeeViewport",
                                                    "data-workType": _vm.analyticalWork(
                                                      subItem
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "添加" +
                                                      _vm._s(
                                                        _vm.analyticalWork(
                                                          subItem
                                                        )
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "editingOperation" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "deleteItem",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteAnOrder(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "iconfont icon-shanchu"
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("删除项目")])
                                  ]
                                )
                              ])
                            ]
                          : [
                              _vm._l(item.employeeList, function(
                                subItem,
                                subIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: subIndex,
                                    staticClass: "employeeListContent"
                                  },
                                  [
                                    _c("div", { staticClass: "staff" }, [
                                      _c("span", {
                                        staticClass: "iconfont icon-shanchu",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deletionOfEmployee(
                                              index,
                                              subIndex
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("i", [
                                          _vm._v(_vm._s(subItem.employeeName))
                                        ]),
                                        _vm._v(" "),
                                        _c("i", [
                                          _vm._v(_vm._s(subItem.postName))
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    item.appointBrokerage === 0
                                      ? [_vm._m(4, true)]
                                      : [
                                          _c(
                                            "div",
                                            {
                                              class:
                                                subItem.appoint === 0
                                                  ? "staffInfo"
                                                  : "staffInfo active",
                                              on: {
                                                click: function($event) {
                                                  return _vm.modifyADesignation(
                                                    item,
                                                    subItem,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "iconfont icon-bianji1"
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    subItem.appoint === 0
                                                      ? "非指定"
                                                      : "指定"
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                    _vm._v(" "),
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "staffInfo",
                                          staticStyle: {
                                            "user-select": "none",
                                            cursor: "no-drop",
                                            "margin-left": "25px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#1E90FF" }
                                            },
                                            [
                                              _vm._v(
                                                "销售" + _vm._s(subIndex + 1)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ],
                                  2
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.employeeList.length < 5,
                                      expression: "item.employeeList.length < 5"
                                    }
                                  ],
                                  staticClass: "addOnSales",
                                  attrs: { "data-tag": "openEmployeeViewport" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openAddStaff(index)
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont icon-tianjia",
                                    attrs: {
                                      "data-tag": "openEmployeeViewport"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-tag": "openEmployeeViewport"
                                      }
                                    },
                                    [_vm._v("添加销售")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "order-add" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "deleteItem",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteAnOrder(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "iconfont icon-shanchu"
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("删除产品")])
                                  ]
                                )
                              ])
                            ]
                      ],
                      2
                    )
                  })
                : [_vm._m(5)]
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tallyOrder FixedBottom" }, [
            _c("div", { staticClass: "totalPrices" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("amountType")(_vm.amountInTotal)))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pendingOrder",
                on: { click: _vm.pendingOrderList }
              },
              [_c("span", [_vm._v("挂单")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "settleAccounts",
                on: { click: _vm.closeAnAccount }
              },
              [_c("span", [_vm._v("结账")])]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择手牌号",
            visible: _vm.theHandNumberPopsUp,
            "custom-class": "handNumberScreeningClose",
            "before-close": _vm.closeTheHandNumber,
            width: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.theHandNumberPopsUp = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "handNumberScreening" },
            _vm._l(_vm.defaultHandNumber, function(item) {
              return _c(
                "span",
                {
                  key: item.hand,
                  class: _vm.returnStyleDisplay(item.hand) ? "active" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectTheHandNumber(item.hand)
                    }
                  }
                },
                [_vm._v(" #" + _vm._s(item.hand) + " ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "manualInput" }, [
            _c("span", [_vm._v("手动输入手牌号")]),
            _vm._v(" "),
            _c("span", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.customizeTheHandNumber,
                    expression: "customizeTheHandNumber",
                    modifiers: { trim: true }
                  }
                ],
                attrs: {
                  type: "text",
                  maxlength: "3",
                  placeholder: "请输入手牌号",
                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                },
                domProps: { value: _vm.customizeTheHandNumber },
                on: {
                  focus: _vm.noDisplay,
                  blur: [
                    _vm.permittedDisplay,
                    function($event) {
                      return _vm.$forceUpdate()
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.customizeTheHandNumber = $event.target.value.trim()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "i",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.selectTheHandNumber(_vm.customizeTheHandNumber)
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改卡备注",
            visible: _vm.cardRemarks,
            align: "center",
            "custom-class": "userDefinedModifiedCardRemarks",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.cardRemarks = $event
            }
          }
        },
        [
          _c("div", { staticClass: "updateCardRemarks" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cardNoteContent,
                  expression: "cardNoteContent"
                }
              ],
              ref: "remark",
              attrs: { placeholder: "请输入卡备注信息", rows: "4", cols: "25" },
              domProps: { value: _vm.cardNoteContent },
              on: {
                focus: _vm.noDisplay,
                blur: _vm.permittedDisplay,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.cardNoteContent = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.cardRemarks = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateCardRemarks }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.inputEquipmentShow
        ? _c(
            "div",
            {
              staticClass: "inputEquipment",
              attrs: { "data-tag": "setProjectFocusClose" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "clickContent",
                  attrs: { "data-tag": "setProjectFocus" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "inputTitle",
                      attrs: { "data-tag": "setProjectFocus" }
                    },
                    [
                      _c("span", { attrs: { "data-tag": "setProjectFocus" } }, [
                        _vm._v("修改价格")
                      ]),
                      _vm._v(" "),
                      _c("span", { attrs: { "data-tag": "setProjectFocus" } }, [
                        _vm._v("（原价："),
                        _c("i", { attrs: { "data-tag": "setProjectFocus" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("amountType")(
                                _vm.setProjectPrice.originalProjectPrice
                              )
                            )
                          )
                        ]),
                        _vm._v("）")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "setProjectRef",
                      staticClass: "priceInput",
                      attrs: { "data-tag": "setProjectFocus" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.setProjectPrice.modifiedOriginalPrice,
                            expression: "setProjectPrice.modifiedOriginalPrice"
                          }
                        ],
                        class: this.setProjectRefIndex === 0 ? "active" : "",
                        attrs: {
                          "data-tag": "setProjectFocus",
                          type: "text",
                          "data-setProjectIndex": "0",
                          onfocus: "this.select()",
                          "data-type": "modifiedOriginalPrice",
                          readonly: ""
                        },
                        domProps: {
                          value: _vm.setProjectPrice.modifiedOriginalPrice
                        },
                        on: {
                          focus: _vm.setProjectPriceFocus,
                          blur: _vm.permittedDisplay,
                          keydown: _vm.setProjectPriceKeydow,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.setProjectPrice,
                              "modifiedOriginalPrice",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.setProjectPrice.modifiedDiscount,
                            expression: "setProjectPrice.modifiedDiscount"
                          }
                        ],
                        class: this.setProjectRefIndex === 1 ? "active" : "",
                        attrs: {
                          "data-tag": "setProjectFocus",
                          type: "text",
                          "data-setProjectIndex": "1",
                          onfocus: "this.select()",
                          "data-type": "modifiedDiscount",
                          readonly: ""
                        },
                        domProps: {
                          value: _vm.setProjectPrice.modifiedDiscount
                        },
                        on: {
                          focus: _vm.setProjectPriceFocus,
                          blur: _vm.permittedDisplay,
                          keydown: _vm.setProjectPriceKeydow,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.setProjectPrice,
                              "modifiedDiscount",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.modifiedPrice,
                            expression: "modifiedPrice"
                          }
                        ],
                        ref: "costFocusRef",
                        class: this.setProjectRefIndex === 2 ? "active" : "",
                        attrs: {
                          "data-tag": "setProjectFocus",
                          type: "text",
                          "data-setProjectIndex": "2",
                          onfocus: "this.select()",
                          "data-type": "modifiedPrice",
                          readonly: ""
                        },
                        domProps: { value: _vm.modifiedPrice },
                        on: {
                          focus: _vm.setProjectPriceFocus,
                          blur: _vm.permittedDisplay,
                          keydown: _vm.setProjectPriceKeydow,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.modifiedPrice = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "inputContent",
                      on: { click: _vm.modifyThePriceInputDevice }
                    },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _vm._m(8),
                      _vm._v(" "),
                      _vm._m(9),
                      _vm._v(" "),
                      _vm._m(10),
                      _vm._v(" "),
                      _vm._m(11),
                      _vm._v(" "),
                      _vm._m(12),
                      _vm._v(" "),
                      _vm._m(13),
                      _vm._v(" "),
                      _vm._m(14),
                      _vm._v(" "),
                      _vm._m(15),
                      _vm._v(" "),
                      _vm._m(16),
                      _vm._v(" "),
                      _vm._m(17),
                      _vm._v(" "),
                      _vm._m(18),
                      _vm._v(" "),
                      _vm._m(19),
                      _vm._v(" "),
                      _vm._m(20),
                      _vm._v(" "),
                      _vm._m(21),
                      _vm._v(" "),
                      _vm._m(22)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "operatingButton",
                      attrs: { "data-tag": "setProjectFocus" }
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: { "data-tag": "setProjectFocus" },
                          on: { click: _vm.setProjectFocusClose }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: !_vm.whetherTheSettlementPriceCanBeModified
                            ? "active"
                            : "",
                          attrs: { "data-tag": "setProjectFocus" },
                          on: { click: _vm.modifyTheOrderSettlementPrice }
                        },
                        [_vm._v("确认")]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("dataModificationElement", {
        ref: "integral",
        attrs: {
          show: _vm.modifyData,
          title: _vm.modifyType === "add" ? "增加积分" : "扣除积分"
        },
        on: {
          noDisplay: _vm.noDisplay,
          permittedDisplay: _vm.permittedDisplay,
          setIntegral: _vm.setIntegral,
          closeMode: function($event) {
            _vm.modifyData = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "打卡", visible: _vm.punchTheWindow, width: "500px" },
          on: {
            "update:visible": function($event) {
              _vm.punchTheWindow = $event
            },
            close: _vm.turnOffTimer
          }
        },
        [
          _c("div", { staticClass: "punchQRCode" }, [
            _c("div", { staticClass: "currentDate" }, [
              _c("span", { staticClass: "time_box" }, [
                _c("span", [_vm._v(_vm._s(_vm.currentTime.time))]),
                _c("i", [_vm._v(":")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.currentTime.minute))]),
                _c("i", [_vm._v(":")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.currentTime.second))])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "month" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.currentTime.month + "月" + _vm.currentTime.day + "日"
                    )
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.currentTime.week))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "qrCode" }, [
              _c("div", { staticClass: "twoDimensionalCodeDisplay" }, [
                _c("img", { attrs: { src: _vm.wechatAddress, alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hint" }, [
                _c("span", { staticClass: "icon" }, [
                  _c("span", { staticClass: "iconfont icon-weixin" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("微信扫码")])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.punchTheWindow = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.punchTheWindow = false
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: {
          src:
            "https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_logo_02cai.png",
          alt: "logo"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nva-item statement" }, [
      _c("span", { staticClass: "iconfont icon-baobiao" }),
      _vm._v(" "),
      _c("span", [_vm._v("报表")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: { "text-align": "center" },
        attrs: { "data-tag": "employeeViewport" }
      },
      [
        _c("span", { staticClass: "iconfont icon-wushuju" }),
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              margin: "10px 0 0",
              color: "#7c7c7c"
            }
          },
          [_vm._v("暂无员工")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "staffInfo",
        staticStyle: { "user-select": "none", cursor: "no-drop" }
      },
      [
        _c("span", {
          staticClass: "iconfont icon-bianji1",
          staticStyle: { color: "rgb(165 163 163)" }
        }),
        _vm._v(" "),
        _c("span", { staticStyle: { color: "rgb(165 163 163)" } }, [
          _vm._v("非指定")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "staffInfo",
        staticStyle: { "user-select": "none", cursor: "no-drop" }
      },
      [
        _c("span", {
          staticClass: "iconfont icon-bianji1",
          staticStyle: { color: "rgb(165 163 163)" }
        }),
        _vm._v(" "),
        _c("span", { staticStyle: { color: "rgb(165 163 163)" } }, [
          _vm._v("非指定")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-content" }, [
      _c("span", { staticClass: "iconfont icon-dingdan" }),
      _vm._v(" "),
      _c("span", [_vm._v("消费项目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "priceTitle" }, [
      _c("span", [_vm._v("原价")]),
      _vm._v(" "),
      _c("span", [_vm._v("折扣")]),
      _vm._v(" "),
      _c("span", [_vm._v("结算价")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "1", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "1", "data-tag": "setProjectFocus" } },
          [_vm._v("1")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "2", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "2", "data-tag": "setProjectFocus" } },
          [_vm._v("2")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "3", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "3", "data-tag": "setProjectFocus" } },
          [_vm._v("3")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "rollback", "data-tag": "setProjectFocus" } },
      [
        _c("i", {
          staticClass: "iconfont icon-zuojiantou",
          attrs: { "data-number": "rollback", "data-tag": "setProjectFocus" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "4", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "4", "data-tag": "setProjectFocus" } },
          [_vm._v("4")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "5", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "5", "data-tag": "setProjectFocus" } },
          [_vm._v("5")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "6", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "6", "data-tag": "setProjectFocus" } },
          [_vm._v("6")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "clear", "data-tag": "setProjectFocus" } },
      [
        _c("i", {
          staticClass: "iconfont icon-chacha",
          attrs: { "data-number": "clear", "data-tag": "setProjectFocus" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "7", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "7", "data-tag": "setProjectFocus" } },
          [_vm._v("7")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "8", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "8", "data-tag": "setProjectFocus" } },
          [_vm._v("8")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "9", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "9", "data-tag": "setProjectFocus" } },
          [_vm._v("9")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "return", "data-tag": "setProjectFocus" } },
      [
        _c("i", {
          staticClass: "iconfont icon-duihao",
          attrs: { "data-number": "return", "data-tag": "setProjectFocus" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: { visibility: "hidden" },
        attrs: { "data-number": "none", "data-tag": "setProjectFocus" }
      },
      [
        _c("i", {
          attrs: { "data-number": "none", "data-tag": "setProjectFocus" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": "0", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": "0", "data-tag": "setProjectFocus" } },
          [_vm._v("0")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { "data-number": ".", "data-tag": "setProjectFocus" } },
      [
        _c(
          "i",
          { attrs: { "data-number": ".", "data-tag": "setProjectFocus" } },
          [_vm._v(".")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: { visibility: "hidden" },
        attrs: { "data-number": "none", "data-tag": "setProjectFocus" }
      },
      [
        _c("i", {
          attrs: { "data-number": "none", "data-tag": "setProjectFocus" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de112f84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de112f84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/paperless/index.vue
// module id = null
// module chunks = 